import React from 'react';
import styled from 'styled-components';
import Component from './component';

const PreviewTitle = ({ field = 'name', ...props }) => <Component field={field} {...props} Element="h2" />;

export default styled(PreviewTitle)`
  margin: 0;
`;
